import { Col, Row } from "react-bootstrap";
import LeapHeaderComponent from "../../leap-components/LeapHeaderComponent";

const HeaderSubComponent = () => {
  return (
    <div>
      <Row className="mb-1">
        <Col className="col-md-12">
          <h1>Licence and Enforcement Access Portal</h1>
        </Col>
      </Row>
      <Row>
        <Col className="col-md-12">
          <h5>{"  "}</h5>
        </Col>
      </Row>
    </div>
  );
};

const Header = () => {
  const headerContent = <HeaderSubComponent />;
  return <LeapHeaderComponent headerContent={headerContent} />;
};

export default Header;
